(ns common.schema.entities.screening-profile.permissions
  (:require [common.features.plan :as plan]
            [common.modules :as modules]
            [common.roles :as roles]))

(defn read-permissions?
  [{:keys [account-current-permissions tenant role tenant-plan]}]
  (and (plan/available :feature/screening tenant role tenant-plan)
       (modules/has-module? account-current-permissions :module/screening)))

(defn disable-permissions?
  [{:keys [tr role entity has-write-permissions?]}]
  (when-not (or (roles/admin? role)
                (has-write-permissions? entity))
    (tr :not-allowed)))

(defn create-permissions?
  [{:keys [tr role entity has-write-permissions?]}]
  (when-not (or (roles/admin? role)
                (has-write-permissions? entity))
    (tr :not-allowed)))
